<div class="dialog-container">
  <h2 mat-dialog-title>Record Bank Withdrawal</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      Enter the withdrawal details for your bank account
    </p>
    
    <form [formGroup]="withdrawForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Amount</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="amount" 
          required numberFormat>
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(withdrawForm.get('amount')?.hasError('required')) {
          <mat-error>
            Amount is required
          </mat-error>
        }
        @if(withdrawForm.get('amount')?.hasError('min')) {
          <mat-error>
            Amount must be greater than $0.01
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Date</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          formControlName="date"
          required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if(withdrawForm.get('date')?.hasError('required')) {
          <mat-error>
            Date is required
          </mat-error>
        }
      </mat-form-field>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Category</mat-label>
        <input 
          matInput 
          type="text" 
          formControlName="category" 
          required>
        <mat-hint>Enter a transaction category</mat-hint>
        @if(withdrawForm.get('category')?.hasError('required')) {
          <mat-error>
            Category is required
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button 
      mat-button 
      type="button" 
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="accent" 
      type="submit" 
      [disabled]="withdrawForm.invalid" 
      (click)="onSubmit()">
      <span>Record Withdrawal</span>
    </button>
  </div>
</div>